import React, { createContext } from "react";
const browserHistoryMemoryContext = createContext({ browserHistory: null });
//Browser history wrapper for Memory router
const BrowserHistoryMemoryContextProvider = ({ children, browserHistory }) => {
    return (React.createElement(browserHistoryMemoryContext.Provider, { value: { browserHistory } }, children));
};
export { browserHistoryMemoryContext, BrowserHistoryMemoryContextProvider };
